<template>
  <div v-if="isNext" class="swiper-button-next" @click="next"></div>
  <div v-else class="swiper-button-prev" @click="prev"></div>
</template>
<script>
import { useSwiper } from "swiper/vue/swiper-vue";

export default {
  props: {
    isNext: {
      type: Boolean,
    },
  },
  setup(props, context) {
    const swiper = useSwiper();

    const prev = () => {
      swiper.value.slidePrev();
      context.emit("swipe", swiper.value.activeIndex);
    };

    const next = () => {
      if (swiper.value.isEnd) {
        context.emit("end");
      } else {
        swiper.value.slideNext();
        context.emit("swipe", swiper.value.activeIndex);
      }
    };

    const jump = (index) => {
      swiper.value.slideTo(index);
    };

    return {
      swiper,
      next,
      prev,
      jump,
    };
  },
};
</script>

<style>
.swiper-button-prev::after,
.swiper-button-next::after {
  display: none;
}
</style>
